import api from '../../../core/api/api';

export const turnosService = {
  getProximosTurnos: async (usuario) => {
    const response = await api.post('/Dashboard/ProximosTurnosTecnico', { usuario });
    return response.data;
  }
};

export default turnosService;
